module.exports = {
      id: "fullscreen-usage",
      viewBox: "0 0 24 24",
      url: "/" + "svg-sprite-f1921bf4f6bf5e98a1b5d71e857b44f0.svg#fullscreen",
      toString: function () {
        return this.url;
      }
    }